import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import {
  Alert,
  Box,
  Button,
  TextField,
  Typography,
  Paper
} from '@mui/material';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [authMessage, setAuthMessage] = useState(() => sessionStorage.getItem("authMessage"));

  const handleSubmit = async (e) => {
    e.preventDefault();
    sessionStorage.removeItem("authMessage");
    setAuthMessage(null);
    const success = await login(username, password);
    if (success) {
      navigate('/');
    } else {
      setError('Invalid credentials');
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          backgroundColor: "#1c2023",
          width: 320,
          borderRadius: 2,
        }}
      >
        <Typography variant="h5" sx={{ color: "#ff6600", mb: 3, textAlign: "center" }}>
          Login
        </Typography>

        {authMessage && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            {authMessage}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            margin="normal"
            InputProps={{ style: { color: "#fff" } }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
            InputProps={{ style: { color: "#fff" } }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />

          {error && (
            <Typography sx={{ color: "red", mt: 1 }}>{error}</Typography>
          )}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#ff6600",
              "&:hover": {
                backgroundColor: "#e65c00",
              },
            }}
          >
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default Login;
